import { PricingPlanType } from '../types/pricingPlans';

export interface PricingPlanConfig {
  name: string;
  description: string;
  features: string[];
  featuresNotIncluded: string[];
  note: string | null;
  price: string;
  themeColor: 'emerald' | 'blue' | 'purple' | 'orange' | 'amber';
  cssClasses: string;
  icon: 'zap' | 'store' | 'crown' | 'star' | 'sparkles';
  isInternal: boolean;
  maxBookingsPerWeek?: number;
  maxB2BOrdersPerMonth?: number;
  upgradeTo: PricingPlanType[];
}

export const PRICING_PLANS_CONFIG: Record<PricingPlanType, PricingPlanConfig> = {
  free: {
    name: 'pricing.free.name',
    description: 'pricing.free.description',
    features: [
      'pricing.free.features.everything',
      'pricing.free.features.bookings',
      'pricing.features.catalogues',
      'pricing.features.unlimited_accounts',
      'pricing.free.features.sms_reminders',
      'pricing.free.features.customer_files',
      'pricing.free.features.sales_tracking',
      'pricing.features.limited_billing',
      'pricing.free.features.commission_form_brides',
      'pricing.features.contract_signatures',
    ],
    featuresNotIncluded: [
      'pricing.features.advanced_analytics',
      'pricing.features.priority_support',
      'pricing.features.custom_integrations',
      'pricing.advancedStore.features.website',
      'pricing.advancedStore.features.requests',
    ],
    note: null,
    price: 'Free',
    themeColor: 'emerald',
    cssClasses: 'bg-emerald-100 text-emerald-800 border-emerald-300',
    icon: 'zap',
    isInternal: true,
    maxBookingsPerWeek: 5,
    maxB2BOrdersPerMonth: 3,
    upgradeTo: ['store', 'brand', 'advanced-store']
  },
  'early-adopter': {
    name: 'pricing.earlyAdopter.name',
    description: 'pricing.earlyAdopter.description',
    features: [
      'pricing.earlyAdopter.features.all',
      'pricing.earlyAdopter.features.bookings',
      'pricing.earlyAdopter.features.priority',
      'pricing.earlyAdopter.features.beta',
      'pricing.features.catalogues',
      'pricing.features.unlimited_accounts',
      'pricing.earlyAdopter.features.sms_reminders',
      'pricing.features.contract_signatures',
    ],
    featuresNotIncluded: [
      'pricing.features.advanced_analytics',
      'pricing.features.custom_integrations',
    ],
    note: null,
    price: 'Free',
    themeColor: 'orange',
    cssClasses: 'bg-orange-100 text-orange-800 border-orange-300',
    icon: 'star',
    isInternal: true,
    maxBookingsPerWeek: 999,
    maxB2BOrdersPerMonth: 999,
    upgradeTo: ['store', 'brand', 'advanced-store']
  },
  store: {
    name: 'pricing.store.name',
    description: 'pricing.store.description',
    features: [
      'pricing.store.features.calendar',
      'pricing.store.features.smart_customer_management',
      'pricing.store.features.orders',
      'pricing.store.features.contracts',
      'pricing.store.features.bookings',
      'pricing.store.features.sms_notifications',
      'pricing.store.features.customer_files',
      'pricing.store.features.sales_tracking',
      'pricing.features.limited_billing',
    ],
    featuresNotIncluded: [
      'pricing.features.advanced_analytics',
      'pricing.features.custom_integrations',
      'pricing.features.priority_support',
      'pricing.advancedStore.features.website',
      'pricing.advancedStore.features.requests',
    ],
    note: null,
    price: 'pricing.store.price',
    themeColor: 'blue',
    cssClasses: 'bg-blue-100 text-blue-800 border-blue-300',
    icon: 'store',
    isInternal: false,
    upgradeTo: ['brand', 'advanced-store', 'free']
  },
  brand: {
    name: 'pricing.brand.name',
    description: 'pricing.brand.description',
    features: [
      'pricing.brand.features.all',
      'pricing.brand.features.bookings',
      'pricing.brand.features.customer_files',
      'pricing.brand.features.sales_tracking',
      'pricing.brand.features.b2b',
      'pricing.brand.features.b2b_form',
      'pricing.brand.features.production',
      'pricing.features.billing',
      'pricing.brand.features.onsite',
      'pricing.features.advanced_analytics',
    ],
    featuresNotIncluded: [
      'pricing.features.custom_integrations',
      'pricing.advancedStore.features.website',
      'pricing.advancedStore.features.requests',
    ],
    note: null,
    price: 'pricing.brand.price',
    themeColor: 'purple',
    cssClasses: 'bg-purple-100 text-purple-800 border-purple-300',
    icon: 'crown',
    isInternal: false,
    upgradeTo: ['advanced-store', 'free', 'store']
  },
  'advanced-store': {
    name: 'pricing.advancedStore.name',
    description: 'pricing.advancedStore.description',
    features: [
      'pricing.advancedStore.features.includesStore',
      'pricing.features.billing',
      'pricing.advancedStore.features.support',
      'pricing.advancedStore.features.phone_assistant',
      'pricing.advancedStore.features.storage',
      'pricing.advancedStore.features.ai',
      'pricing.advancedStore.features.website',
      'pricing.advancedStore.features.requests',
      'pricing.features.custom_integrations',
    ],
    featuresNotIncluded: [],
    note: null,
    price: 'pricing.advancedStore.price',
    themeColor: 'amber',
    cssClasses: 'bg-amber-100 text-amber-800 border-amber-300',
    icon: 'sparkles',
    isInternal: false,
    upgradeTo: ['free', 'store', 'brand']
  }
};
